import React from 'react';
import { AttachMediaModal } from '../../../../components/AttachMediaModal';
import { ElementWrapper } from '../../../../components/ElementWrapper';
import { IElement } from '../../../../models/Element';
import { HomeImageRightDescriptionBlueContent } from './HomeImageRightDescriptionBlueThemeContent';
import { HomeImageRightDescriptionBlueElement } from './HomeImageRightDescriptionBlueThemeElement';
import { HomeImageRightDescriptionBlueFigure } from './HomeImageRightDescriptionBlueThemeFigure';

interface HomeImageRightDescriptionProps {
  index: number;
  data: HomeImageRightDescriptionBlueElement;
  updateData: (element: IElement, index: number) => void;
}

export const HomeImageRightDescriptionBlueFC: React.FC<
  HomeImageRightDescriptionProps
> = ({ index, data, updateData }) => {
  const update = (
    fieldsToUpdate: Partial<HomeImageRightDescriptionBlueElement>
  ) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <>
      <AttachMediaModal
        modalId={`${data.name}-${data.id}`}
        updateCallback={(image, image_alt) =>
          update({ image_preview: image, image_preview_alt: image_alt })
        }
      />

      <ElementWrapper elementIndex={index}>
        <div className="home-image-right-description-blue">
          <div className="position-relative align-items-center showcase">
            <HomeImageRightDescriptionBlueContent data={data} update={update} />
            <HomeImageRightDescriptionBlueFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
